const prefix = 'app'

export const LOGIN = prefix + '/login'

export const AUTHORIZE = prefix + '/authorize'
